(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('indicadorFaixas', IndicadorFaixasDirective);

  function IndicadorFaixasDirective() {
    return {
      restrict: 'E',
      controller: 'IndicadorFaixasCtrl',
      controllerAs: 'vm',
      scope: {},
      bindToController: {
        indicador: '='
      },
      transclude: true,
      templateUrl: 'views/tipos_ocorrencias/indicador_faixas.html'
    };
  }
}());
